export const SUPPORT_TICKET_ASSIGNMENT_DEFAULT = 'default';
export const SUPPORT_TICKET_ASSIGNMENT_MINE = 'mine';
export const SUPPORT_TICKET_ASSIGNMENT_UNASSIGNED = 'unassigned';
export const SUPPORT_TICKET_ASSIGNMENT_ALL = 'all';
export const SUPPORT_TICKET_MANAGER_PREFIX = 'manager:';

export const getSupportTicketFilterParams = (value) => {
    if (!value || value === SUPPORT_TICKET_ASSIGNMENT_DEFAULT) return {};

    if (String(value).startsWith(SUPPORT_TICKET_MANAGER_PREFIX)) {
        return {
            manager_id: String(value).replace(SUPPORT_TICKET_MANAGER_PREFIX, ''),
        };
    }

    if (value === SUPPORT_TICKET_ASSIGNMENT_ALL) {
        return {
            assignment: SUPPORT_TICKET_ASSIGNMENT_ALL,
        };
    }

    return {
        assignment: value,
    };
};

export const getSupportTicketManagerName = (ticket) => (
    ticket?.manager?.name || 'не распределен'
);

export const getSupportTicketText = (ticket) => {
    if (!ticket) return 'Тикет не открыт';

    const ticketCode = ticket?.ticketCode || ticket?.ticket_code || ticket?.id;
    const status = ticket?.isClosed ? 'закрыт' : 'открыт';

    return `Тикет ${status}${ticketCode ? `: ${ticketCode}` : ''}`;
};

const normalizeBooleanFlag = (value, fallback = false) => {
    if (value === undefined || value === null) return fallback;
    if (typeof value === 'string') return ['1', 'true', 'yes'].includes(value.toLowerCase());

    return Boolean(value);
};

const pickValue = (...values) => values.find((value) => value !== undefined && value !== null);

const normalizeTicketClosed = (event, eventTicket, currentTicket) => {
    const status = String(pickValue(
        event?.status,
        event?.systemStatus,
        event?.system_status,
        eventTicket?.status,
        eventTicket?.systemStatus,
        eventTicket?.system_status,
    ) ?? '').toLowerCase();

    if (['closed', 'close', 'done', 'закрыт'].includes(status)) return true;
    if (['new', 'open', 'work', 'opened'].includes(status)) return false;

    return normalizeBooleanFlag(
        pickValue(event?.isClosed, event?.is_closed, eventTicket?.isClosed, eventTicket?.is_closed),
        Boolean(currentTicket?.isClosed),
    );
};

export const getSupportTicketFromEvent = (event, currentTicket = null) => {
    const eventTicket = event?.supportTicket || event?.support_ticket || {};

    return {
        ...(currentTicket || {}),
        id: pickValue(event?.ticketId, event?.ticket_id, eventTicket?.id, currentTicket?.id),
        ticketNumber: pickValue(event?.ticketNumber, event?.ticket_number, eventTicket?.ticketNumber, eventTicket?.ticket_number, currentTicket?.ticketNumber),
        ticketCode: pickValue(event?.ticketCode, event?.ticket_code, eventTicket?.ticketCode, eventTicket?.ticket_code, currentTicket?.ticketCode),
        managerId: pickValue(event?.manager?.id, event?.managerId, event?.manager_id, eventTicket?.manager?.id, eventTicket?.managerId, eventTicket?.manager_id, currentTicket?.managerId),
        manager: pickValue(event?.manager, eventTicket?.manager, currentTicket?.manager),
        ticketTypeId: pickValue(
            event?.ticketTypeId,
            event?.ticket_type_id,
            eventTicket?.ticketTypeId,
            eventTicket?.ticket_type_id,
            eventTicket?.ticket_type?.id,
            eventTicket?.type?.id,
            currentTicket?.ticketTypeId,
        ),
        isClosed: normalizeTicketClosed(event, eventTicket, currentTicket),
        ratingSubmitted: normalizeBooleanFlag(
            pickValue(event?.ratingSubmitted, event?.rating_submitted, eventTicket?.ratingSubmitted, eventTicket?.rating_submitted),
            Boolean(currentTicket?.ratingSubmitted),
        ),
        openedAt: pickValue(event?.openedAt, event?.opened_at, eventTicket?.openedAt, eventTicket?.opened_at, currentTicket?.openedAt),
        closedAt: pickValue(event?.closedAt, event?.closed_at, eventTicket?.closedAt, eventTicket?.closed_at, currentTicket?.closedAt, null),
    };
};
